import {ROUTES} from "@constants"
import i18n from "@/lang/i18n";

export default [
  {
    path: 'small-category',
    name: ROUTES.ADMIN.SMALL_CATEGORY_LIST,
    meta: {
      title: '小カテゴリ一覧',
      breadcrumb: [
        {
          'label': 'breadcrumbs.Small Category List',
        },
      ],
      activeKey: 'admin.small-category.list'
    },

    component: () => import("@pages/admin/qa_chatbots/SmallCategoryList"),
  },

  {
    path: 'small-category/create',
    name: ROUTES.ADMIN.SMALL_CATEGORY_CREATE,
    meta: {
      title: '小カテゴリ一覧',
      breadcrumb: [
        {
          'label': 'breadcrumbs.Small Category List',
          'href': '/admin/small-category?filters.big_category_id.equal=all&filters.medium_category_id.equal=all',
        },
        {
          'label': 'breadcrumbs.Small Category Create',
        },
      ],
      activeKey: 'admin.small-category.create'
    },
    component: () => import("@pages/admin/qa_chatbots/SmallCategoryCreateOrEdit"),
  },

  {
    path: 'small-category/:id/edit',
    name: ROUTES.ADMIN.SMALL_CATEGORY_EDIT,
    meta: {
      title: '小カテゴリ一覧',
      breadcrumb: [
        {
          'label': 'breadcrumbs.Small Category List',
          'href': '/admin/small-category?filters.big_category_id.equal=all&filters.medium_category_id.equal=all',
        },
        {
          'label': 'breadcrumbs.Small Category Edit',
        },
      ],
      activeKey: 'admin.small-category.edit'
    },
    component: () => import("@pages/admin/qa_chatbots/SmallCategoryCreateOrEdit"),
  },
];
